// @mui
import { alpha, styled } from '@mui/material/styles';
import { Box, Stack, Typography } from '@mui/material';
// components
import Logo from '../../components/Logo';
import Iconify from '../../components/Iconify';
// hooks
import useLocales from '../../hooks/useLocales';

// ----------------------------------------------------------------------

const RootStyle = styled('aside')(({ theme }) => ({
  position: 'relative',
  display: 'none',
  width: '46%',
  maxWidth: 660,
  minHeight: '100dvh',
  overflow: 'hidden',
  backgroundColor: '#102B46',
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const PanelImage = styled('img')(() => ({
  position: 'absolute',
  inset: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  objectPosition: '62% center',
}));

const Overlay = styled('div')(() => ({
  position: 'absolute',
  inset: 0,
  background:
    'linear-gradient(180deg, rgba(9, 33, 57, 0.95) 0%, rgba(11, 38, 63, 0.88) 42%, rgba(12, 36, 59, 0.76) 100%)',
}));

const Content = styled('div')(({ theme }) => ({
  zIndex: 1,
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  padding: theme.spacing(6, 7),
  [theme.breakpoints.down('lg')]: {
    padding: theme.spacing(5),
  },
}));

const FeatureRow = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.25),
  color: alpha('#fff', 0.86),
}));

// ----------------------------------------------------------------------

export default function AuthBrandPanel() {
  const { translate } = useLocales();

  const features = [
    translate('auth.hero.feature1'),
    translate('auth.hero.feature2'),
    translate('auth.hero.feature3'),
  ];

  return (
    <RootStyle data-ph-capture="safe">
      <PanelImage src={`${process.env.PUBLIC_URL}/images/auth/b2b-team-workspace.jpg`} alt="" />
      <Overlay />

      <Content>
        <Logo white disabledLink={false} sx={{ width: 128 }} />

        <Stack spacing={4} sx={{ my: 'auto', maxWidth: 450 }}>
          <Stack spacing={2}>
            <Typography variant="h2" sx={{ color: 'common.white', lineHeight: 1.16, letterSpacing: -1 }}>
              {translate('auth.hero.title')}
            </Typography>
            <Typography sx={{ color: alpha('#fff', 0.74), maxWidth: 420 }}>
              {translate('auth.hero.subtitle')}
            </Typography>
          </Stack>

          <Stack spacing={1.5}>
            {features.map((feature) => (
              <FeatureRow key={feature}>
                <Iconify icon="eva:checkmark-circle-2-fill" sx={{ width: 20, height: 20, color: '#7BE0B2' }} />
                <Typography variant="body2">{feature}</Typography>
              </FeatureRow>
            ))}
          </Stack>
        </Stack>

        <Box sx={{ width: 48, height: 3, borderRadius: 3, bgcolor: '#7BE0B2' }} />
      </Content>
    </RootStyle>
  );
}
